import * as React from "react";
import { Spoiler as MantineSpoiler } from "@mantine/core";
import styled, { css } from "styled-components";
const StyledSpoiler = styled(MantineSpoiler)(
  ({ theme }) => css`
    .mantine-Spoiler-control {
      color: ${theme.colors.link.default};
    }
  `
);
const Spoiler = ({
  maxHeight,
  children = void 0,
  className = void 0,
  showLabel = "Show more",
  hideLabel = "Hide"
}) => /* @__PURE__ */ React.createElement(StyledSpoiler, { maxHeight, showLabel, hideLabel, className }, children);
export default Spoiler;
